// src/data/hire-ruby-and-rails.data.js

// Existing base data (kept as is, but now directly referenced within the main content object)
export const solutionsData = [
    {
        title: "Access Vetted Talent",
        description:
            "When you hire Ruby on Rails programmers from us, you get developers who are fully vetted for both their technical expertise & communication skills. They’re ready to build top-quality apps & work smoothly with your team.",
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
    },
    {
        title: "View Matches in Seconds",
        description:
            "No more wasting time sifting through endless resumes! Quickly find the right fit for your project with just a few clicks. Whether you need a RoR developer for hire for a short-term task or a long-term role, we make the process fast & easy.",
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
    },
    {
        title: "Save with Global Hires",
        description:
            "Our network of Ruby on Rails developers spans 190 countries, meaning you have access to a pool of 450,000 talented professionals. By hiring globally, you can save up to 58% compared to traditional hiring methods—without compromising on quality.",
        noBorder: true,
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
    },
    {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "Get Expert Support",
        description:
            "Hiring Ruby on Rails developers is easy with our expert recruiters by your side. From finding the right fit to getting the best talent for your project, we ensure a smooth hiring experience every step of the way.",
    },
];

export const hirefaqData = [
    {
        id: "collapseOne",
        question: "How quickly can Ruby on Rails engineers start working on my project?",
        answer:
            "At Bitsclan IT Solutions, our Ruby on Rails engineers can be onboarded within 48–72 hours after project confirmation. We handle setup, access permissions, and tool alignment (GitHub, Jira, Slack, etc.) to ensure seamless integration with your team from day one.",
    },
    {
        id: "collapseTwo",
        question: "What does your onboarding process include?",
        answer:
            "Our onboarding covers everything from technical environment setup and repository access to communication alignment. We schedule a kickoff session to introduce engineers to your product architecture, sprint schedule, and workflows, ensuring immediate productivity and alignment with business goals.",
    },
    {
        id: "collapseThree",
        question: "Can I scale my Rails development team as the project grows?",
        answer:
            "Yes. You can scale your team up or down in a matter of days depending on workload or new milestones. Whether you need to onboard additional backend engineers, QA specialists, or DevOps experts, we ensure fast and flexible scalability without delays or contractual lock-ins.",
    },
    {
        id: "fourth",
        question:
            "How do you ensure collaboration between your Rails engineers and our in-house team?",
        answer:
            "Our engineers adapt to your preferred tools, time zones, and communication cadence. They join your daily standups, sprint reviews, and code retrospectives via Slack, Zoom, or Teams, maintaining real-time coordination and transparent progress tracking.",
    },
    {
        id: "fifth",
        question: "How do you guarantee developer quality and performance?",
        answer:
            "Every Ruby on Rails engineer at Bitsclan IT Solutions undergoes a 5-stage vetting process covering architecture design, performance optimization, testing frameworks, and real world deployment experience. You onboard developers with proven expertise in production-grade systems, not entry-level talent.",
    },
    {
        id: "sixth",
        question: "What if the assigned engineer isn’t the right fit for my project?",
        answer:
            "If an engineer doesn’t meet your expectations, we’ll replace them immediately at no additional cost. Our focus is on maintaining delivery quality, ensuring your project remains on track with zero downtime or productivity loss.",
    },
    {
        id: "seventh",
        question: "How do you manage offboarding and project transitions?",
        answer:
            "Before offboarding, we conduct a structured knowledge transfer, including updated documentation, environment credentials, and deployment details. All source code, data, and credentials are securely handed over, maintaining full IP ownership and continuity for your team.",
    },
    {
        id: "eighth",
        question: "Do your engineers work under NDA and IP protection?",
        answer:
            "Yes. Every engagement is governed by strict NDAs and IP transfer clauses. Your code, assets, and databases remain your sole property, protected through secure version control and enterprise-grade confidentiality measures.",
    },
    {
        id: "ninth",
        question:
            "How do you maintain code consistency and security during transitions?",
        answer:
            "We follow Git-based branching strategies, peer code reviews, and automated CI/CD pipelines to ensure smooth transitions without regression. All credentials and repositories are audited before handover to ensure secure, traceable ownership transfer.",
    },
    {
        id: "tenth",
        question: "Do you provide post engagement or transition support?",
        answer:
            "Yes. We offer post-transition support for up to two weeks (or as agreed) to ensure your internal team has everything needed for smooth project continuity. Optional retainer models are also available for long-term maintenance and feature expansion.",
    },
];

export var mainBannerImg = { // Retaining var as per your original, though const is often preferred
    backgroundImage: `url(/images/hire-page-images/hire-ror-banner.avif)`,
    factBackgroundImage: `url(/images/hire-page-images/hire-ror-quick-section.avif)`,
};

export const servicesData = [
    {
        title: "Ruby on Rails Consulting",
        description:
            "Leverage expert advice & strategic insights from our experienced RoR developers. Whether you're launching a new project or optimizing an existing one, we guide you every step of the way.",
        icon: "/images/hire-page-icons/hire-ror-icons1.svg",
    },
    {
        title: "Ruby on Rails web Development",
        description:
            "Build feature-rich, scalable web applications with our expert RoR developers. We ensure seamless performance, flexibility, & hassle-free maintenance to keep your web solutions running smoothly.",
        icon: "/images/hire-page-icons/hire-ror-icons2.svg",
    },
    {
        title: "Ruby on Rails API Development",
        description:
            "Our RoR specialists develop robust APIs that ensure seamless communication between applications. Whether integrating third-party services or managing internal data, we've got you covered.",
        icon: "/images/hire-page-icons/hire-ror-icons3.svg",
    },
    {
        title: "CMS & Portal Development",
        description:
            "Hire our RoR developers to build scalable, customizable CMS & web portals. Our solutions ensure ease of management & adaptability to your unique business requirements.",
        icon: "/images/hire-page-icons/hire-ror-icons4.svg",
    },
    {
        title: "Migration to Ruby on Rails",
        description:
            " Planning to migrate to Ruby on Rails? Our experts ensure a seamless transition while preserving data integrity & functionality. We manage every detail for a smooth & hassle-free migration.",
        icon: "/images/hire-page-icons/hire-ror-icons5.svg",
    },
    {
        title: "Integration with Existing Solutions",
        description:
            " Enhance your systems with seamless RoR integration. Our developers ensure your Ruby on Rails applications work flawlessly with existing tools, optimizing performance & efficiency.",
        icon: "/images/hire-page-icons/hire-ror-icons6.svg",
    },
    {
        title: "ROR eCommerce Solutions",
        description:
            " Develop a high-performing eCommerce platform with our RoR experts. We craft engaging, feature-rich online stores with seamless user experiences & easy management capabilities.",
        icon: "/images/hire-page-icons/hire-ror-icons7.svg",
    },
    {
        title: "ROR Support & Maintenance",
        description:
            " Keep your Ruby on Rails applications running optimally with our expert support & maintenance services. We handle bug fixes, performance enhancements, & updates to ensure uninterrupted functionality.",
        icon: "/images/hire-page-icons/hire-ror-icons8.svg",
    },
];

export const steps = [
    {
        title: "Choose your Engagement Model",
        description:
            "Select the engagement model that fits your needs—Full-Time, Part-Time, or Hourly. Whether you need a long-term partner or someone for a short-term task, we have flexible options.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
    },
    {
        title: "Screen & Select Ruby On Rails Developers",
        description:
            "Browse through our pool of skilled RoR developers for hire. Pick the best candidates based on their profiles & get ready to move forward with the right fit for your project.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
    },
    {
        title: "Conduct One-on-One Interview",
        description:
            "After you’ve shortlisted your candidates, interview them to evaluate their skills. You can ask both theoretical & practical questions to ensure they’re the perfect match for your Ruby on Rails development services.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
    },
    {
        title: "Onboard Ruby on Rails Developers",
        description:
            "Once you’ve made your decision, the final candidate will join your team within 24-48 hours after confirmation. It’s that simple to bring Ruby on Rails developers into your project!",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
    },
];

export const facts = [
    {
        text: "<strong>40+ Experienced RoR Developers:</strong> Our team consists of more than 40 skilled Ruby on Rails programmers, ready to build powerful, scalable web applications.",
    },
    {
        text: "<strong>Average Experience of 25.98 Years:</strong> With nearly 26 years of combined experience, our RoR developers bring a wealth of expertise to every project.",
    },
    { text: "<strong>Certified Ruby on Rails Experts: </strong>Our team includes certified Ruby on Rails developers with in-depth knowledge of the latest tools & frameworks." },
    {
        text: "<strong>Cloud-Native & Serverless Expertise:</strong> We specialize in building scalable web development solutions using cloud-native & serverless architectures to ensure reliability & performance.",
    },
    { text: "<strong>Advanced DevOps Practices:</strong> Our developers work with a mature DevOps culture, ensuring fast, secure, & efficient delivery through continuous integration & delivery (CI/CD)." },
    { text: "Reliance on a <strong> mature DevOps culture.</strong>" },
    {
        text: "<strong>Versatile Experience:</strong> Whether it’s big data, IoT, machine learning, or blockchain integration, our team has experience in handling complex & innovative projects with Ruby on Rails.",
    },
];

export const hiringDetails = [
    {
        text: "Hourly Hiring",
        hours: "24 - 48",
        timeUnit: "hours",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "Duration", // Dynamic label
        duration: "8 Hrs/Day",     // Dynamic value
        minimumDaysLabel: "Minimum Days", // Dynamic label
        minimumDays: "30 Days",           // Dynamic value
        billingLabel: "Billing",       // Dynamic label
        billing: "Monthly",            // Dynamic value
        startWorkPhrase: "Start work in "
    },
    {
        text: "Full Time Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Get started within "
    },
    {
        text: "Part Time Hiring",
        hours: "24 - 48",
        timeUnit: "hours",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "Duration",
        duration: "4 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Launch in "
    },
];


export const tabs = [
    "Languages",
    "Libraries & UI Libraries",
    "Frameworks",
    "Testing",
    "Platforms",
];

export const tabItems = [
    { tab: "Languages", name: "Ruby", icon: "/images/tech-stack-icons/ruby.svg" },
    { tab: "Languages", icon: "/images/icon7.png", name: "HTML5" },
    { tab: "Languages", icon: "/images/icon6.png", name: "CSS3" },
    { tab: "Languages", icon: "/images/icontwo.png", name: "JavaScript" },

    { tab: "Libraries & UI Libraries", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
    { tab: "Libraries & UI Libraries", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind CSS" },
    { tab: "Libraries & UI Libraries", icon: "/images/tech-stack-icons/react.svg", name: "React.js" },
    { tab: "Libraries & UI Libraries", icon: "/images/tech-stack-icons/angular.svg", name: "Angular" },
    { tab: "Libraries & UI Libraries", icon: "/images/tech-stack-icons/vue-js.svg", name: "Vue.js" },

    { tab: "Frameworks", name: "Ruby on Rails", icon: "/images/tech-stack-icons/rails.svg" },
    { tab: "Frameworks", icon: "/images/tech-stack-icons/graph.svg", name: "GraphQl" },

    { tab: 'Platforms', icon: '/images/cloud3.png', name: 'AWS' },
    { tab: 'Platforms', icon: '/images/DigitalOcean.png', name: 'Digital Ocean' },
    { tab: 'Platforms', icon: '/images/tech-stack-icons/heroku.svg', name: 'Heroku' },

    { tab: "Testing", name: "Redis", icon: "/images/tech-stack-icons/rspec.svg", },
    { tab: "Testing", name: "Jest", icon: "/images/tech-stack-icons/jest.svg", },
];

export const techCombinations = [
    {
        title: "Ruby on Rails + React + PostgreSQL",
        description:
            "Ruby on Rails as the backend framework, React for a dynamic front-end, & PostgreSQL as a database help build scalable & high-performing web applications.",
        icons: [
            { icon: "rails.svg", altText: "Ruby on Rails logo" },
            { icon: "react.svg", altText: "React logo" },
            { icon: "postgres.svg", altText: "PostgreSQL logo" },
        ],
    },
    {
        title: "Ruby on Rails + Angular + MySQL",
        description:
            "Ruby on Rails for server-side logic, Angular for a modern front-end, & MySQL as a reliable relational database create robust web solutions for businesses.",
        icons: [
            { icon: "rails.svg", altText: "Ruby on Rails logo" },
            { icon: "angular.svg", altText: "Angular logo" },
            { icon: "mysql-whale-icon.svg", altText: "MySQL logo" },
        ],
    },
    {
        title: "Ruby on Rails + Vue.js + MongoDB",
        description:
            "Vue.js on the front end, Ruby on Rails as the backend, & MongoDB as a NoSQL database provide an efficient stack for interactive & flexible applications.",
        icons: [
            { icon: "rails.svg", altText: "Ruby on Rails logo" },
            { icon: "vue-js.svg", altText: "Vue.js logo" },
            { icon: "mongodb.svg", altText: "MongoDB logo" },
        ],
    },
    {
        title: "Ruby on Rails + GraphQL + PostgreSQL",
        description:
            "GraphQL enables flexible data queries, Ruby on Rails handles the server logic, & PostgreSQL ensures secure & structured data storage for modern applications.",
        icons: [
            { icon: "rails.svg", altText: "Ruby on Rails logo" },
            { icon: "graphql.svg", altText: "GraphQL logo" },
            { icon: "postgres.svg", altText: "PostgreSQL logo" },
        ],
    },
];

export const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
        "@type": "Question",
        "name": "What is Ruby on Rails (RoR) used for?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ruby on Rails (RoR) is a powerful web application framework used to build dynamic, database-driven websites & applications. It’s ideal for developing scalable web apps, eCommerce platforms, content management systems, & custom software solutions"
        }
    }, {
        "@type": "Question",
        "name": "How much does it cost to develop with Ruby on Rails?",
        "acceptedAnswer": {
            "@type": "@Answer",
            "text": "The cost of developing with Ruby on Rails varies depending on the complexity of your project, the number of features required, & the development timeline. We offer customized quotes based on your specific needs to ensure you get the best value."
        }
    }, {
        "@type": "Question",
        "name": "What is the hourly rate for a Ruby on Rails developer?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "The hourly rate for a Ruby on Rails developer can range widely based on their experience level & the project’s requirements. At Bitsclan, we offer competitive rates that reflect the expertise & quality of our RoR developers."
        }
    }, {
        "@type": "Question",
        "name": "Is Ruby on Rails good for web application development?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Ruby on Rails is an excellent choice for web application development. It’s known for its efficiency, scalability, & strong community support, making it ideal for building robust & high-performance web applications."
        }
    }, {
        "@type": "Question",
        "name": "Is Ruby on Rails frontend or backend?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ruby on Rails is primarily a backend framework, that handles the server-side logic, database interactions, & application structure. However, it can be seamlessly integrated with front-end technologies like HTML, CSS, & JavaScript."
        }
    }, {
        "@type": "Question",
        "name": "What sets your Ruby on Rails developers apart?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our Ruby on Rails developers stand out due to their deep expertise, commitment to quality, & passion for innovation. They are skilled in delivering custom solutions that are both efficient & scalable, ensuring your project’s success."
        }
    }]
}


// --- Consolidated Page Content Object ---
export const hireRubyAndRailsPageContent = {
    // SEO Data
    helmet: {
        title: "Hire Ruby on Rails Programmers | RoR Development Services",
        description: "Hire expert Ruby on Rails developers for scalable, robust web applications. Tailored RoR development services to fit your business needs.",
        schema: schemaData, // Reference schemaData directly
    },

    // HirePageBanner Component Props (following your requested structure)
    hirePageBanner: {
        diffBannerBackgroundImage: mainBannerImg.backgroundImage,
        image: "", // Assuming this is consistently empty
        mainHeading: "Hire Elite <span>Ruby on Rails</span> Developers for Scalable & Secure Web Solutions",
        shortHeading: "Build High Performance Web Apps with Expert Ruby on Rails Developers",
        content: "Strengthen your team with expert Ruby on Rails engineers who build secure, scalable, and high-performance web applications. Our top-tier talent integrates seamlessly into your workflow to accelerate delivery and elevate product outcomes.",
        btnText: "Consult our RoR developers",
        bannerList: [
            { list: "Pre-Vetted Developers" },
            { list: "Top Talent" },
            { list: "Timezone Alignment" },
            { list: "Faster & Cost-Effective Hiring" },
        ],
    },

    // HirePageExperties Component Props
    hirePageExperties: {
        btnText: "Schedule a Call Today",
        heading: "We Offer Ruby on Rails Development Services",
        discription: "At Bitsclan, we craft scalable, secure, & efficient solutions tailored to your business needs. Our RoR developers are ready to support you at every stage of development, including post-launch maintenance. As a leading Ruby on Rails development company, we seamlessly integrate with your projects, allowing you to focus on business growth.",
        servicesData: servicesData, // Reference servicesData directly
    },

    // DevelopmentPerformance Component Props
    developmentPerformance: {
        btnText: "Hire a developer today",
        heading: "Why Choose Us to Hire",
        greenHeading: "Ruby on Rails Programmers",
        subHeading: "At Bitsclan, we combine Ruby on Rails with the latest frontend & mobile technologies to create powerful, scalable applications that are perfect for your business needs. Whether you’re building a web platform or a mobile solution, our approach ensures fast development, smooth performance, & a seamless user experience.",
        solutions: solutionsData, // Reference solutionsData directly
    },

    // HireCombinationSection Component Props
    hireCombinationSection: {
        combinations: techCombinations, // Reference techCombinations directly
        heading: "Best RoR Combinations For Exceptional Development",
        description: "Got it! Here's how the sections will be structured for Ruby on Rails, following the same description style as your reference image.",
    },

    // HirePageSteps Component Props
    hirePageSteps: {
        btnText: "Let’s Find Your Perfect Developer",
        heading: "Hire Ruby On Rails Programmers in 4 Simple Steps",
        subHeading: "Hiring RoR developers has never been easier! At Bitsclan, our streamlined 4-step process ensures you get top talent quickly, efficiently, & seamlessly.",
        steps: steps, // Reference steps directly
    },

    // CoverTheStack Component Props
    coverTheStack: {
        whereStart: "Languages",
        mainHeading: "Hire Expert Ruby on Rails Developers for Scalable & Secure Web Solutions",
        subHeading: "At Bitsclan, we empower your web development journey with a robust Ruby on Rails tech stack that ensures efficiency, scalability, & security. Our experienced RoR developers specialize in building high-performance, custom web applications tailored to your business needs.",
        tabs: tabs, // Reference tabs directly
        tabItems: tabItems, // Reference tabItems directly
    },

    // HireExpertFacts Component Props
    hireExpertFacts: {
        btnText: "book an appointment",
        heading: "Quick Facts About ",
        greenHeading: "Our Ruby on Rails Team",
        facts: facts, // Reference facts directly
        diffBannerBackgroundImage: mainBannerImg.factBackgroundImage,
    },

    // HirePageAppIdea Component Props
    hirePageAppIdea: {
        heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
        content: "Hire skilled Ruby on Rails developers to build scalable, high-performing web applications tailored to your business needs. Our experts specialize in rapid development, ensuring efficient & robust solutions.",
    },

    // HirePageEngagementModels Component Props
    hirePageEngagementModels: {
        btnText: "Get Started Now",
        hiringDetails: hiringDetails, // Reference hirignDetails directly
        headingContent: [
            {
                "text": "Our Flexible"
            },
            {
                "text": "Engagement Models"
            },
        ],
        discription: "At Bitsclan, we offer flexible engagement models based on your specific needs. Choose from Full-Time, Part-Time, or Hourly options. Whether you need a single RoR developer for hire or a dedicated team, we ensure seamless collaboration & high efficiency for your project."
    },

    // TrendsInsights Component Props
    trendsInsights: {
        specificClass: "mobile-dev-page",
        category: "all",
    },

    // SecondFaq Component Props
    secondFaq: {
        faqs: hirefaqData, // Reference faqData directly
        specificClass: "mobile-dev-page",
        mainHeading: "Frequently Asked Questions",
        subHeading: "Discover answers to common questions about Ruby on Rails.",
    },
};

export const hireRubyAndRailsengagementModeContent = {
    shortHeading: "Our Engegement Models",
    heading: "Seamless Collaboration, Proven Delivery, Measurable Results",
    subheading: "Choosing the right engagement model is crucial. We offer flexible options, from dedicated development teams to project-based partnerships, ensure transparency, seamless collaboration, & maximum efficiency aligned with your AI, web, or IT project goals.",
    models: [
        {
            icon: "/images/engagement-model-gifs/hourly-icon.svg",
            index: 1,
            iconWidth: 40,
            title: "Flexible Team",
            description: "Bring in Rails experts as an extension of your existing team. Ideal for rapid MVP launches, prototype builds, and on demand product updates. Our engineers work seamlessly with your internal teams, adapting to your schedule, tools, and sprint cycles.",
        },
        {
            icon: "/images/engagement-model-gifs/price-icon.svg",
            index: 2,
            iconWidth: 35,
            title: "Dedicated Team",
            description: "A full stack Ruby on Rails team focused entirely on your project from architecture design and backend APIs to frontend integration, DevOps, and QA. Perfect for businesses scaling products or managing multiple digital platforms with complex data and integrations.",
        }
    ],
    cta: {
        text: "Build Fast, Build Right, Elite Ruby on Rails Talent.",
        button: "Hire Your RoR Expert Today",
        link: "/contact-us",
    },
}